module.exports = __webpack_public_path__ + "img/brouilles-on.0f33dec9.svg";